import React, { useState } from 'react';
import { Button, ContextMenu, ContextMenuItem, useBreakpoint } from '@axiom/ui';

import { localStorageUtil } from '../../utils/local-storage-util';

export type TalentSearchOptionsProps = {
  updateState: () => Promise<void> | void;
};

const defaultFN: TalentSearchOptionsProps['updateState'] = () => {};

export const TalentSearchOptions = ({
  updateState = defaultFN,
}: TalentSearchOptionsProps) => {
  const { isMobile } = useBreakpoint();
  const isFluidLayout = isMobile;
  const [showingPricing, setShowingPricing] = useState(
    !!localStorageUtil.showPricing().get()
  );

  const handleShowPricing = async () => {
    localStorageUtil.showPricing().set(!showingPricing);
    setShowingPricing(!showingPricing);

    await updateState();
  };

  return (
    <ContextMenu
      name="SEARCH_OPTIONS"
      fluid={isFluidLayout}
      anchor={
        <Button
          icon="settings"
          name="SEARCH_OPTIONS_BUTTON"
          variation="minimal"
          pattern="secondary"
          fluid={isFluidLayout}
        >
          Options
        </Button>
      }
    >
      <ContextMenuItem
        name={`OPTION_${showingPricing ? 'HIDE' : 'SHOW'}`}
        onClick={async () => {
          await handleShowPricing();
        }}
      >
        {showingPricing ? 'Hide' : 'Show'} pricing
      </ContextMenuItem>
    </ContextMenu>
  );
};
